module.exports = __webpack_public_path__ + "media/put-stone.1ae51044.mp3";